import axiosInstance from "./api/axiosInstance";
const BASE_ROUTE = process.env.REACT_APP_BASE_ROUTE;

// Usamos o axios puro aqui porque essas rotas não exigem token de autenticação.
const registerClient = async (clientData) => {
  const response = await axiosInstance.post(`${BASE_ROUTE}client`, clientData);
  console.log(response);
  return response.data;
};

const verifyUsername = async (username) => {
  const response = await axiosInstance.get(
    `${BASE_ROUTE}client/verify-username?username=${username}`
  );
  return response.data;
};


const updateClientData = async (patchDtos, ipAddress = null) => {
  let url = "client/by-token";

  // Se o IP foi passado, adiciona na query string
  if (ipAddress) {
    url += `?ipAddress=${ipAddress}`;
  }

  // O patchDtos continua indo no corpo (segundo parâmetro do axios.patch)
  const response = await axiosInstance.patch(url, patchDtos);
  return response.data;
};

export const clientService = {
  registerClient,
  verifyUsername,
  updateClientData, // Adiciona a nova função ao objeto exportado
};
